/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaRightArrow: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="rightArrow" viewBox="0 0 18 14">
      <path
        d="M14.586 6L10.293 1.707C9.902 1.316 9.902 0.682997 10.293 0.292997C10.684 -0.0970028 11.317 -0.0980028 11.707 0.292997L17.707 6.293C18.098 6.684 18.098 7.317 17.707 7.707L11.707 13.707C11.316 14.098 10.683 14.098 10.293 13.707C9.903 13.316 9.902 12.683 10.293 12.293L14.586 8H1C0.448 8 0 7.552 0 7C0 6.448 0.448 6 1 6H14.586Z"
        fill="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaRightArrow)
